import React from 'react';
import HeroSlide from '../components/hero-slide/HeroSlide';
import { Link } from 'react-router-dom';
import { OutlineButton } from '../components/button/Button';
import MovieList from '../components/movie-list/MovieList';

const Home = () => {
  return (
    <>
      <HeroSlide />

      <div className="container">
        <div className="section mb-3">
          <div className="section__header mb-2">
            <h2>Trending Movies</h2>
            <Link to={`/movie`}>
              <OutlineButton className="small">View more</OutlineButton>
            </Link>
          </div>
          <MovieList category={'movie'} type={'popular'} />
        </div>
        
        <div className="section mb-3">
          <div className="section__header mb-2">
            <h2>Top Rated Movies</h2>
            <Link to={`/movie`}>
              <OutlineButton className="small">View more</OutlineButton>
            </Link>
          </div>
          <MovieList category={'movie'} type={'top_rated'} />
        </div>

        <div className="section mb-3">
          <div className="section__header mb-2">
            <h2>Trending TV shows</h2>
            <Link to={`/tv`}>
              <OutlineButton className="small">View more</OutlineButton>
            </Link>
          </div>
          <MovieList category={'tv'} type={'popular'} />
        </div>

        <div className="section mb-3">
          <div className="section__header mb-2">
            <h2>Top Rated TV shows</h2>
            <Link to={`/tv`}>
              <OutlineButton className="small">View more</OutlineButton>
            </Link>
          </div>
          <MovieList category={'tv'} type={'top_rated'} />
        </div>

      </div>
    </>
  )
}

export default Home